import React from "react";
import { Thumbnail } from "@culturehq/components";

import calendar from "images/badges/calendar.png";
import cup from "images/badges/cup.png";
import letter from "images/badges/letter.png";
import book from "images/badges/book.png";
import { Creator } from "chq";

const badges = { calendar, cup, letter, book };

type BadgeProps = {
  badge: string;
  points: undefined | number;
};

const Badge: React.FC<BadgeProps> = ({ badge, points }) => {
  let src = badge;

  if (Object.prototype.hasOwnProperty.call(badges, badge)) {
    src = badges[badge as keyof typeof badges];
  }

  return (
    <div className="badge-img">
      <img src={src} alt={badge} />
      {points && (
        <div className="points-increment">
          <span>+{points}</span>
        </div>
      )}
    </div>
  );
};

type NotificationBodyProps = {
  actor?: null | Creator;
  badge?: string;
  children: React.ReactNode;
  points?: number;
};

const NotificationBody: React.FC<NotificationBodyProps> = ({ actor, badge, children, points }) => (
  <>
    {actor && (
      <Thumbnail className="Thumbnail" image={actor?.avatar?.thumbUrl} title={actor.name} />
    )}
    {badge && <Badge badge={badge} points={points} />}
    <div className="notification-body-wrapper">
      <div className="notification-body">{children}</div>
    </div>
  </>
);

export default NotificationBody;
